import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

export const GetTeamsQueryKey = 'GET_ALL_TEAMS';

export const useGetTeamsQuery = () => {
  const { fetchAllTeams } = useServicesContext();

  return useQuery({
    queryKey: [GetTeamsQueryKey],
    queryFn: fetchAllTeams,
  });
};
